export enum MemberPreferencesType {
    PREFERREDWEBSITELANGUAGE = 7
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/member-preferences.enum.ts